import { createRouter, createWebHistory } from 'vue-router'
import PeopleIndex from '@/app/views/people/index/component.vue'

const routes = [
  {
    path: '/',
    name: 'peopleIndex',
    component: PeopleIndex,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  // scrollBehavior () {
  //   return { top: 0, behavior: 'smooth' }
  // },
  routes
})

export default router

export {
  routes
}
